module.exports = "//static.hsappstatic.net/LoginUI/static-1.15982/img/chatspot-icon.png"